import { render, staticRenderFns } from "./BalanceDetailSale.vue?vue&type=template&id=7fffa717&scoped=true"
import script from "./BalanceDetailSale.vue?vue&type=script&lang=js"
export * from "./BalanceDetailSale.vue?vue&type=script&lang=js"
import style0 from "./BalanceDetailSale.vue?vue&type=style&index=0&id=7fffa717&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fffa717",
  null
  
)

export default component.exports